import { borrarLocal, escribirLocal, leerLocal } from '../almacenamientoSeguro';

/**
 * Lo que ha decidido el usuario en ESTE móvil sobre Face ID o huella.
 *
 * Aparte de `biometria.ts` para no cargar el plugin: lo usa también el cierre de sesión, que se
 * importa desde toda la web.
 *
 * No es un secreto: solo dice si quiere que se le pida. Valores: `activada`, `rechazada`,
 * `activar-al-entrar` (lo pidió en Configuración) o nada (aún no se le ha ofrecido).
 */
export const CLAVE_PREFERENCIA_BIOMETRIA = 'movil.biometria';

export const biometriaActivada = (): boolean =>
	leerLocal(CLAVE_PREFERENCIA_BIOMETRIA) === 'activada';

export const yaSeOfrecioBiometria = (): boolean => leerLocal(CLAVE_PREFERENCIA_BIOMETRIA) !== null;

export const activarBiometria = (): void => escribirLocal(CLAVE_PREFERENCIA_BIOMETRIA, 'activada');

/** «Ahora no», o desactivarla en Configuración: deja de pedirse; se ofrece en el siguiente login. */
export const rechazarBiometria = (): void =>
	escribirLocal(CLAVE_PREFERENCIA_BIOMETRIA, 'rechazada');

/** Lo guardado dejó de valer (contraseña o biometría cambiadas): se le volverá a ofrecer. */
export const olvidarBiometria = (): void => borrarLocal(CLAVE_PREFERENCIA_BIOMETRIA);

/** Desde Configuración: no hay contraseña que guardar, así que se activa en el siguiente login. */
export const pedirActivarAlEntrar = (): void =>
	escribirLocal(CLAVE_PREFERENCIA_BIOMETRIA, 'activar-al-entrar');

export const quiereActivarAlEntrar = (): boolean =>
	leerLocal(CLAVE_PREFERENCIA_BIOMETRIA) === 'activar-al-entrar';

/**
 * De quién es lo guardado: el NIF de quien lo activó. El acceso de Face ID es de una cuenta, no
 * del móvil; si en ese móvil entra otra persona con su contraseña, lo guardado no es suyo.
 *
 * Se guarda el NIF tal cual: cifrarlo no protegería nada (hay pocos NIF posibles, se sacarían
 * todos en segundos), y ya está en la caja fuerte del móvil junto a la contraseña.
 */
const CLAVE_TITULAR = 'movil.biometria.titular';

export const recordarTitular = (nif: string): void => escribirLocal(CLAVE_TITULAR, nif);

export const esDelTitular = (nif: string): boolean => leerLocal(CLAVE_TITULAR) === nif;

/**
 * «Entrar con contraseña» desde el bloqueo recarga la app: la pantalla de login no puede volver a
 * pedir la cara nada más llegar. En `sessionStorage` (sobrevive a la recarga, no a cerrar la app)
 * y de un solo uso.
 */
const CLAVE_SALTAR = 'movil.biometria.saltar';

export const saltarFaceIdUnaVez = (): void => {
	try {
		sessionStorage.setItem(CLAVE_SALTAR, '1');
	} catch {
		/* sin almacenamiento, el login pedirá la cara: se puede cancelar */
	}
};

export const tocaSaltarFaceId = (): boolean => {
	try {
		const toca = sessionStorage.getItem(CLAVE_SALTAR) === '1';
		sessionStorage.removeItem(CLAVE_SALTAR);

		return toca;
	} catch {
		return false;
	}
};
